console.debug((new Date).getFullYear() + ' (c) Ilyin Aleksey <alksily[at]outlook[dot]com>');

export const encode = (str) => btoa(unescape(encodeURIComponent(str)));
export const decode = (str) => decodeURIComponent(escape(atob(str)));

// default empty query list
location.query = {};

// build query params
window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
    location.query[key] = value;
});

export const resizeImage = async (file) => {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = function (event) {
            let img = new Image();
            img.src = event.target.result;

            img.onload = function () {
                let maxWidth = 1200;
                let maxHeight = 1200;

                let width = img.width;
                let height = img.height;

                if (width > maxWidth) {
                    height *= maxWidth / width;
                    width = maxWidth;
                }

                if (height > maxHeight) {
                    width *= maxHeight / height;
                    height = maxHeight;
                }

                let canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;

                let ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, width, height);

                let resizedDataUrl = canvas.toDataURL('image/jpeg', 0.8);
                resolve(resizedDataUrl);
            };
        };

        reader.onerror = function (error) {
            reject(error);
        };

        reader.readAsDataURL(file);
    });
}

export const dataURLtoBlob = (dataURL) => {
    let arr = dataURL.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        byteString = atob(arr[1]),
        n = byteString.length,
        u8arr = new Uint8Array(n);

    while (n--) {
        u8arr[n] = byteString.charCodeAt(n);
    }

    return new Blob([u8arr], {type: mime});
}
